import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { ActivatedRoute, Router } from '@angular/router';
import { Media } from '../model/media.class';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { MediaElement } from '../model/mediaElement.class';

@Component({
    selector: 'app-media-upload',
    templateUrl: './media.upload.component.html'
})
export class MediaUploadComponent {

    public media: Media;
    public message = '';
    public hasBaseDropZoneOver = false;
    public hasAnotherDropZoneOver = false;
    public isUploading = false;
    public notUploaded = true;
    public videos;
    public maxVideoSize;

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.userService.videoUploader.clearQueue();
        this.route.params.subscribe(
            (params) => {
                userService.get(params['mediaId'], 'media').subscribe(
                    (media) => {
                        this.media = media as Media;
                        this.userService.getBy(String(this.media.mid), this.media.publisher.publisherId, 'getVideos').subscribe(
                            (data) => this.videos = data
                        );
                        this.maxVideoSize = this.media.publisher.maxVideoSize * 1048576;
                });
            });
    }

    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    public checkFileName(name: string): boolean {
        if (name.endsWith('.mp4')) {
            return true;
        }
        return false;
    }


    /*
    Alle noch nicht hochgeladenen Videos werden Hochgeladen
    */
    public uploadVideos() {
        let amountVideos = 0;
        let amountErrorVideos = 0;
        this.message = 'Einen Moment bitte, die Videos werden hochgeladen...';
        let errorMessage = '';
        const component = this;
        component.notUploaded = false;
        component.isUploading = true;
        const URL = UserService.baseUrl.concat('files/' + this.media.publisher.publisherId + '/' + this.media.mid + '/videos');
        this.userService.videoUploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        this.userService.videoUploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
            if (response === '-2') {
                errorMessage += 'Fehler beim Hochladen von ' + item.file.name + '\n';
                amountErrorVideos++;
            }
            if (response === '-1') {
                errorMessage += 'Die Datei ' + item.file.name + ' ist zu groß\n';
                amountErrorVideos++;
            }
            if (response === '-3') {
                errorMessage = 'Die Datei ' + item.file.name + ' ist keine mp4\n';
                amountErrorVideos++;
            }
        }
        this.userService.videoUploader.onCompleteAll = function () {
            component.message = (amountVideos -amountErrorVideos ) + ' Videos wurden erfolgreich hochgeladen!\n';
            component.message += errorMessage
            component.isUploading = false;
            component.userService.videoUploader.queue = [];
            component.userService.getBy(String(component.media.mid), component.media.publisher.publisherId, 'getVideos').subscribe(
                (data) => component.videos = data
            );
        };

        // Remove from queue all files that are not mp4 and that are too large
        let i = this.userService.videoUploader.queue.length;
        while (i--) {
            if (!this.checkFileName(this.userService.videoUploader.queue[i].file.name)) {
                this.userService.videoUploader.queue.splice(i, 1);
            }
            else if (this.userService.videoUploader.queue[i].file.size > this.maxVideoSize) {
                this.userService.videoUploader.queue.splice(i, 1);
            }
        }
        amountVideos = this.userService.videoUploader.queue.length;

        if (amountVideos === 0) {
            component.message = 'Keine Videos wurden hochgeladen. Nur mp4 Dateien sind erlaubt...'
        }

        for (const item of this.userService.videoUploader.queue) {
            const element: MediaElement = new MediaElement(item.file.name, 'video', this.media);
            this.userService.create(element, 'mediaElement').subscribe(
                () => item.upload()
            );
        }
    }


    /*
    Ein einzelnes Video wird hochgeladen
    */
    public uploadVideo(video: any) {
        this.message = 'Einen Moment bitte, die Videos werden hochgeladen...';
        let errorMessage = '';
        const component = this;
        video.isUploading = true;
        const URL = UserService.baseUrl.concat('files/' + this.media.publisher.publisherId + '/' + this.media.mid + '/videos');
        this.userService.videoUploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        this.userService.videoUploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
            if (response === '-2') {
                errorMessage = 'Fehler beim Hochladen von ' + item.file.name + '\n';
            }
            if (response === '-1') {
                errorMessage = 'Die Datei ' + item.file.name + ' ist zu groß\n';
            }
            if (response === '-3') {
                errorMessage = 'Die Datei ' + item.file.name + ' ist keine mp4\n'
            }
            if (response === '0') {
                errorMessage = 'Das Video wurden erfolgreich hochgeladen!';
            }
        }
        this.userService.videoUploader.onCompleteAll = function () {
            component.message = errorMessage;
            component.isUploading = false;
            component.userService.videoUploader.queue.splice(component.userService.videoUploader.queue.indexOf(video), 1);
            component.userService.getBy(String(component.media.mid), component.media.publisher.publisherId, 'getVideos').subscribe(
                (data) => component.videos = data
            );
        };

        const element: MediaElement = new MediaElement(video.file.name, 'video', this.media);
        this.userService.create(element, 'mediaElement').subscribe(
                (data) => {
                    video.upload();
                }
            );
    }

    /*
    Ein einzelnes Video wird gelöscht
    */
    deleteVideo(video: any) {
        this.userService.deleteVideo(this.media.publisher.publisherId, this.media.mid, video).subscribe(
            (data) => {;
                if (data._body) {
                    this.message = video + ' wurde erfolgreich gelöscht.';
                    this.videos.splice(this.videos.indexOf(video), 1);
                }
                else {
                    this.message = 'Fehler beim Löschen von ' + video;
                }
                
            },
            (error) => this.message = 'Fehler beim Löschen von ' + video
        );
    }

    /*
    Alle Videos werden gelöscht
    */
    deleteAllVideos() {
        this.userService.videoUploader.queue = [];
        this.message = '';
        for (const video of this.videos) {
            this.userService.deleteVideo(this.media.publisher.publisherId, this.media.mid, video).subscribe(
                (data) => {
                    if (data._body) {
                        this.message += video + ' wurde erfolgreich gelöscht.\n';
                        this.videos.splice(this.videos.indexOf(data));
                    }
                    else {
                        this.message += 'Fehler beim Löschen von ' + video + '\n';
                    }
                },
                (error) => this.message += 'Fehler beim Löschen von ' + video + '\n'
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/mediaUpload/media.upload.component.ts